import {observer} from 'mobx-react-lite'
import {useLocation} from 'react-router-dom'
import {useEffect} from 'react'
import clubStore from '../../../storage/ClubStore'
import appStore from '../../../storage/AppStore'
import PageLayout from '../../PageLayout'
import Child from '../ParentMember/Child'
import '../Parent/parent.css'

const MemberAbout = () => {
  const location = useLocation()
  useEffect(() => {
    clubStore.child.getChild()
  }, [location.pathname])
  return (
    <PageLayout
      header={
        <div className="flex justify-content-between align-items-center">
          <h3 className="m-0">{appStore.tr.about_me}</h3>
        </div>
      }
    >
      <div className="grid children-grid">
        <Child child={clubStore.child.child} url_base={'/member'}/>
      </div>
    </PageLayout>
  )
}

export default observer(MemberAbout)